module.exports = __webpack_public_path__ + "img/error.a60f7b6d.png";